/**
 * @module actions/customers
 */
import axios from 'axios'
import {
  API_URL,
  SET_CUSTOMERS
} from '../constants'

/**
 * @description Getting employees from API and dispatching event
 * @return {Promise} Axios promise
 */
export function getShopOwners (id) {
  id = (typeof id !== 'undefined') ? id : 0
  let url = API_URL + '/ShopOwner/' + id
  return dispatch => {
    return axios.get(url).then((res) => {
      dispatch({
        type: SET_CUSTOMERS,
        shopowners: res.data
      })
      return res
    })
  }
}

/**
 * @description Getting shop owner from API
 * @return {Promise} Axios promise
 */
export function getShopOwner (id) {
  let url = API_URL + '/ShopOwner/Get/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Creating/saving a shop owner
 * @return {Promise} Axios promise
 */
export function CreateSaveShopOwner (data) {
  let url = API_URL + '/ShopOwner/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Getting shop from API
 * @return {Promise} Axios promise
 */
export function getShopList (id) {
  let url = API_URL + '/Shop/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Add/Remove shop for shop owner
 * @return {Promise} Axios promise
 */
export function updateShop (data) {
  let url = API_URL + '/ShopOwner/Shop/Post/'
  return dispatch => {
    return axios.post(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/shopowners.js